import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Map from "./Pages/Map";
import Dashboard from "./Pages/Dashboard";
import FaultCodes from "./Pages/FaultCodes";
import Charging from "./Pages/Charging";
import Geofence from "./Pages/Geofence";
import Parking from "./Pages/Parking";
import Violation from "./Pages/Violation";
import VhmdTrace from "./Pages/VhmdTrace";
import EcoDriving from "./Pages/EcoDriving";
import RefboxTemperature from "./Pages/RefboxTemperature";
import Analysis from "./Pages/Analysis";
import Workshop from "./Pages/Workshop";
import TransferFiles from "./Pages/TransferFiles";
import Login from './Pages/Login';
import Layout from './components/Layout';
import "boxicons/css/boxicons.min.css";
import EMS from './Pages/EMS';
import ICL from './Pages/ICL';
import Trips from './Pages/Trips';
import ProductList from './Pages/ProductList';



const App = () => {
  return (
    <Router> {/* Set basename to match your subdirectory */}
      <Routes>
        {/* Public Route - Login (outside layout) */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes - Wrapped with Layout */}
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/map" element={<Map />} />
                <Route path="/ProductList" element={<ProductList />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/EMS" element={<EMS />} />
                <Route path="/ICL" element={<ICL />} />
                <Route path="/trips" element={<Trips />} />
                <Route path="/fault-codes" element={<FaultCodes />} />
                <Route path="/charging" element={<Charging />} />
                <Route path="/geofence" element={<Geofence />} />
                <Route path="/parking" element={<Parking />} />
                <Route path="/violation" element={<Violation />} />
                <Route path="/vhmd-trace" element={<VhmdTrace />} />
                <Route path="/eco-driving" element={<EcoDriving />} />
                <Route path="/refbox-temperature" element={<RefboxTemperature />} />
                <Route path="/analysis" element={<Analysis />} />
                <Route path="/workshop" element={<Workshop />} />
                <Route path="/transfer-files" element={<TransferFiles />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;